module.exports = __webpack_public_path__ + "img/gal_19.368b15b2.png";